import React, {Component} from "react"

import {LabelsSelector} from "../LabelsSelector";
import {Spinner} from "../Spinner";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import { withTranslation } from 'react-i18next';

class BusinessUnitLabelsManagerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            assignedLabels: this.props.initialLabels,
            availableLabels: null,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.getAgencyLabels();
    }

    getAgencyLabels() {
        const { t } = this.props;
        new APIClient(API_URL + `agency/labels`).call('GET')
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({availableLabels: response.result});
                } else {
                    alert(response.error_message)
                }
            })
            .catch((error) => {
                alert(t('business_unit_labels.error_occurred'))
            });
    }

    assignLabelsToBusinessUnit(labels) {
        const { t } = this.props;
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/labels`).call('PUT', {labels: labels})
            .then((response) => {
                if (response.status === 'OK') {
                    this.setState({assignedLabels: labels});
                    this.props.onLabelsChange(this.props.businessUnitId, labels)
                } else {
                    alert(response.error_message)
                }
            })
            .catch((error) => {
                alert(t('business_unit_labels.error_occurred'))
            });

    }

    handleChange(selectedLabels) {
        this.assignLabelsToBusinessUnit(selectedLabels)
    }

    render() {
        if (this.state.assignedLabels !== null && this.state.availableLabels !== null) {
            return <LabelsSelector
                availableLabels={this.state.availableLabels}
                selectedLabels={this.state.assignedLabels}
                onChangeSelection={this.handleChange}
            />
        } else {
            return <Spinner color="positive small"/>
        }
    }
}

export const BusinessUnitLabelsManager = withTranslation()(BusinessUnitLabelsManagerComponent);
